class CharacterValidator {
  constructor() {
    this.restrict = 'A';
    this.require = 'ngModel';
    this.scope = {};

    /**
     *  basic - Decimal 32-126 + Decimal 160-255
     *  extented - Decimal 32-126 + Decimal 160-255 + Decimal 256-383 + Decimal 384-591 + Decimal 688-767
     *  supplement - Decimal 32-126 + Decimal 160-255
     * Link
     * @param  {Object} scope
     * @param  {Object} element
     * @param  {Object} attrs
     * @param  {Array} requiredCtrls
     * @return {Void}
     */
    this.link = (scope, element, attrs, modelCtrl) => {
      modelCtrl.$validators.characters = (modelValue) => {

        let regrexp = '';

        switch(attrs.characterValidator) {

          case 'basic':  regrexp = /^[\x20-\x7E]+$/;
                        break;
          case 'extented':  regrexp = /^[\x20-\x7E\xA0-\u024F\u02B0-\u02FF]+$/;
                        break;
          case 'supplement':  regrexp = /^[\x20-\x7E\xA0-\xFF]+$/;
                        break;
          case 'number':  regrexp = /^[\x30-\x39]+$/;
                        break;
        }
        if (regrexp.test(modelValue) || modelValue === undefined || modelValue === null || modelValue === '') {
          // input is valid
          return true;
        }

        // input is invalid
        return false;
      };

    };
  }

  /**
   * Factory
   * @return {Object}
   */
  static directiveFactory() {
    CharacterValidator.instance = new CharacterValidator();
    return CharacterValidator.instance;
  }
}

export default CharacterValidator;



/** WEBPACK FOOTER **
 ** ./src/app/directives/formValidators/characterValidator.js
 **/